import React from "react";
import "./TermsAndConditions.css";

export default function TermsAndConditions() {
  return (
    <div className="tos">
      <header>
        <h1>TERMS AND CONDITIONS</h1>
      </header>
      <div>
        <p>
          <strong>TERMS AND CONDITIONS</strong>
        </p>
        <p>&nbsp;</p>
        <p>Website Terms and Conditions of Use</p>
        <p>&nbsp;</p>
        <ol>
          <li>
            <strong>TERMS</strong>
          </li>
        </ol>
        <p>
          By accessing Gupscorner.com (“Gup’s Corner”), owned and operated by
          Gup’s Corner, LLC, you are agreeing to be bound by these web site
          Terms and Conditions of Use, all applicable laws and regulations, and
          agree that you are responsible for compliance with any applicable
          local laws. If you do not agree with any of these terms, you are
          prohibited from using or accessing this site. The materials contained
          in this web site are protected by applicable copyright and trademark
          law.
        </p>
        <p>&nbsp;</p>
        <ol start="2">
          <li>
            <strong>DESCRIPTION OF SERVICE</strong>
          </li>
        </ol>
        <p>
          Gup’s Corner currently provides you (“Users”) with an interactive
          community and discussion chatroom and forums (collectively the
          “Forum”), in which Users can discuss, among other things, daily
          fantasy sports. Through Gup’s Corner and the Forums, users are able to
          become members, browse content, rankings, lineups and promotions,
          engage in various discussions via member blogs, send private messages
          and contribute to the Gup’s Corner online community. Gup’s Corner also
          provides access to numerous online resources, including various
          communication tools, forums, articles, reviews, guides, hyperlinks,
          personalized content and branded programming through its network of
          affiliates (collectively, the “Service”). Unless explicitly stated
          otherwise, any new features that augment or enhance the current
          Service, including the release of new Gup’s Corner affiliates,
          software, forum groups, or content, shall be subject to the Terms of
          Service. You understand and agree that Gup’s Corner assumes no
          responsibility for the timeliness, deletion, delivery or failure to
          store any User communication or personalized settings. In addition,
          Gup’s Corner holds the rights to modify, discontinue, or suspend any
          aspect of the Service at any time. Gup’s Corner may also choose,
          without notice or liability, to limit or restrict access to portions
          or all of its features or any other aspect of the Service. You are
          responsible for obtaining access to the Service and all associated
          connection fees to the Internet or other Web connection (such as
          Internet service provider or airtime charges) as well as all equipment
          necessary to make such connection to the Service. You agree that you
          may not resell, lease, license, assign, or redistribute the Service or
          the Content (defined below), in whole or in part, to any third party.
          You further agree that you will not: (a) make any Service or Content
          available to, or use any Service or Content for the benefit of, anyone
          other than yourself, (b) sell, resell, license, sublicense,
          distribute, rent or lease any Service or Content, or include any
          Service or Content in a service bureau or outsourcing offering, (c)
          interfere with or disrupt the integrity or performance of any Service
          or third-party data contained therein, (d) attempt to gain
          unauthorized access to any Service or Content or its related systems
          or networks, (e) frame or mirror any part of the Service or Content,
          (f) access any portion of the Service or Content in order to build a
          competitive product or service, or (g) reverse engineer, decompile,
          modify or create any derivative work from any portion of the Service
          (to the extent such restriction is permitted by law).
        </p>
        <p>&nbsp;</p>
        <ol start="3">
          <li>
            <strong>ELIGIBILITY</strong>
          </li>
        </ol>
        <p>
          In order to participate in the service, you must be thirteen (13)
          years of age or older at the time of registration.
        </p>
        <p>&nbsp;</p>
        <ol start="4">
          <li>
            <strong>USE LICENSE</strong>
          </li>
        </ol>
        <ul>
          <li>
            Permission is granted to temporarily download one copy of the
            materials (information or software) on Gup’s Corner for personal,
            non-commercial transitory viewing only. This is the grant of a
            license, not a transfer of title, and under this license you may
            not:
            <ul>
              <li>modify or copy the materials;</li>
              <li>
                use the materials for any commercial purpose, or for any public
                display (commercial or non-commercial);
              </li>
              <li>
                attempt to decompile or reverse engineer any software contained
                on Gup’s Corner;
              </li>
              <li>
                remove any copyright or other proprietary notations from the
                materials; or
              </li>
            </ul>
          </li>
        </ul>
        <p>
          &nbsp;&nbsp;&nbsp; transfer the materials to another person or
          “mirror” the materials on any other server.
        </p>
        <p>&nbsp;</p>
        <p>
          This license shall automatically terminate if you violate any of these
          restrictions and may be terminated by Gup’s Corner, LLC at any time.
          Upon terminating your viewing of these materials or upon the
          termination of this license, you must destroy any downloaded materials
          in your possession whether in electronic or printed format.
        </p>
        <p>&nbsp;</p>
        <ul>
          <li>Forum Submissions</li>
        </ul>
        <p>
          This provision governs your conduct, your rights, and Gup’s Corner,
          LLC’s rights with respect to any text, photograph, video, post,
          communication, music, audio/sound recording, artwork, ratings, reviews
          or other materials or information you make associated with Gup’s
          Corner’s Forum (“Submission”). When you submit a Submission, you agree
          to the following:
        </p>
        <p>&nbsp;</p>
        <ol>
          <li>
            your Submission is original, accurate, created by you, and not an
            impersonation;
          </li>
          <li>
            you are over the age of majority, or, if a minor, your parent or
            legal guardian consents to your submission;
          </li>
          <li>
            you are not an employee of Gup’s Corner, LLC nor do you work for an
            affiliate or agency of Gup’s Corner, LLC hired by Gup’s Corner, LLC
            to promote and/or sell Gup’s Corner, LLC products; OR, if you are
            employee of Gup’s Corner, LLC or work for an affiliate or agency of
            Gup’s Corner, LLC hired by Gup’s Corner, LLC to promote and/or sell
            Gup’s Corner, LLC products, you agree to include a clear and
            conspicuous disclosure of your relationship with Gup’s Corner, LLC
            in your Submission;
          </li>
          <li>
            your Submission is not false, misleading, offensive, profane,
            vulgar, obscene, derogatory, defamatory, libelous, slanderous, or
            otherwise inappropriate;
          </li>
          <li>
            your Submission does not contain content which infringes any third
            party’s copyright, patent, trademark, trade secret, right of
            publicity, right of privacy, moral rights, and/or any other
            applicable personal or proprietary rights;
          </li>
          <li>
            your Submission does not contain content which violates any law,
            statute, ordinance or regulation or content that engages in,
            encourages, advocates, or provides instructions for conduct that
            would constitute a criminal or civil offense under any law, statute,
            ordinance or regulation;
          </li>
          <li>
            your Submission does not contain material or content that is, or may
            reasonably be considered to be, hate speech, whether directed at an
            individual or group, or that is otherwise unlawfully threatening or
            unlawfully harassing to any individual, partnership, corporation, or
            political body;
          </li>
          <li>
            your Submission does not contain content or materials intended to
            create disruption or to mislead others, such as posting multiple
            Submissions in an effort to monopolize the forum or posting a
            Submission unrelated to the forum’s designated topic or theme;
          </li>
          <li>
            your Submission does not contain content which includes third party
            websites, addresses, email addresses, contact information, phone
            numbers, other information or opinions about an identified or
            reasonably identifiable individual or private information (including
            sensitive information) without obtaining prior consent from that
            individual for sharing such information with Gup’s Corner, LLC;
          </li>
          <li>
            your Submission does not contain programming or materials containing
            any Trojan horses, viruses, worms, harmful code, or other
            potentially damaging information, programs, or file; and
          </li>
          <li>
            Gup’s Corner, LLC’s use of your Submission does not violate these
            Terms and will not cause injury to any person or entity.
          </li>
        </ol>
        <p>
          If the Submission is related in any way to a promotion, sweepstakes,
          contest, giveaway, or similar program, Additional Terms may apply. Any
          opinions, advice, statements, services, offers, or other information
          contained in Submissions expressed or made available on the Sites are
          those of the respective author(s) or distributor(s) and not of Gup’s
          Corner, LLC. We neither endorse nor guarantee the accuracy,
          completeness, or usefulness or any such Submission.
        </p>
        <p>&nbsp;</p>
        <p>
          Gup’s Corner, LLC does not and cannot review all Submissions posted to
          or created by users accessing the Site and is not in any manner
          responsible for the content of these Submissions. You acknowledge that
          by providing you with the ability to view and distribute user
          generated content on the Site, Gup’s Corner, LLC is merely acting as a
          passive conduit for such distribution and is not undertaking any
          obligation or liability relating to any Submissions or activities on
          the Site. Gup’s Corner, LLC will have no obligation to post or use any
          Submission(s). Gup’s Corner, LLC reserves the right to block or remove
          Submissions and/or Users that it determines to be (a) abusive,
          defamatory, or obscene, (b) fraudulent, deceptive, or misleading, (c)
          in violation of a copyright, trademark or; other intellectual property
          right of another or (d) violates any law or regulation or (e)
          offensive or otherwise unacceptable to Gup’s Corner, LLC at its sole
          discretion..
        </p>
        <p>&nbsp;</p>
        <p>
          By submitting a Submission, you grant each of the following to GUP’S
          CORNER, LLC:
        </p>
        <p>&nbsp;</p>
        <p>
          a non-exclusive, worldwide, perpetual, irrevocable, fully paid-up,
          royalty-free, fully sub licensable and transferable right and license
          to use, monitor, review, reproduce, modify, adapt, publish, translate,
          create derivative works from, distribute, transmit, display, and
          perform such Submission(s), in whole or in part, in any media, format
          or technology, online or offline, whether now known or hereafter
          discovered, and in any manner including, but not limited to, all
          promotional, public viewing and/or commenting (whether on Gup’s
          Corner, LLC’s web pages or on third party web pages), advertising,
          marketing, merchandising, publicity, and commercial uses and ancillary
          uses thereof, without any further notice or payment to or permission
          needed from you (except where prohibited by law);
        </p>
        <p>&nbsp;</p>
        <p>
          an unrestricted, worldwide, perpetual, irrevocable, fully paid-up,
          royalty-free, fully sublicensable and transferable right and license
          to use your name, nickname, user name, biographical information, vocal
          recordings of you, and/or any illustrations, photographic or
          videographic clips, portraits, likenesses or pictures of you or any
          other indicia of your right of publicity rights (collectively “Your
          Personal Content”) as contained in your Submission(s), in composite or
          distorted form or as otherwise incorporated into other creative works
          of authorship, in any media, format or technology, online or offline,
          whether now known or hereafter discovered, and in any manner
          including, but not limited to, all promotional, public viewing and/or
          commenting (whether on GUP’S CORNER, LLC’s web pages or on third party
          web pages), advertising, marketing, merchandising, publicity, and
          commercial uses and ancillary uses thereof, without any further notice
          or payment to or permission needed from you (except where prohibited
          by law).
        </p>
        <p>&nbsp;</p>
        <p>
          You also agree to waive any applicable moral rights as contained in
          your Submission(s) for any of the proposed uses listed above.
        </p>
        <p>&nbsp;</p>
        <p>
          By submitting a Submission, you agree to release, hold harmless and
          indemnify on behalf of yourself and your successors, assigns and
          representatives, Gup’s Corner, LLC and each of its respective
          officers, directors and employees from and against any and all claims,
          suits, actions, demands, liabilities and damages of any kind
          whatsoever arising out of or in connection with the use of such
          Submission, including, without limitation, any and all claims for
          false advertising, copyright infringement, invasion of privacy,
          violation of the right of publicity or of moral rights, and/or
          defamation. Without limiting the foregoing, in no event will you be
          entitled to, and you waive any right to, enjoin, restrain or interfere
          with use of the Submission or Your Personal Content embodied in such
          Submission or the exploitation of any of the Gup’s Corner, LLC’s
          rights as noted above.
        </p>
        <p>&nbsp;</p>
        <p>
          You understand that Gup’s Corner, LLC is relying upon your
          representations, grants of rights, waivers and releases in permitting
          you to submit a Submission. You acknowledge that you may not terminate
          or rescind the grants of rights and licenses and/or the releases
          contained in this Agreement.
        </p>
        <p>&nbsp;</p>
        <p>
          Gup’s Corner, LLC does not guarantee that you will have any
          opportunity to edit or delete your Submission. You acknowledge that
          you, not Gup’s Corner, LLC, are responsible for the contents of any
          Submission(s).
        </p>
        <p>&nbsp;</p>
        <ol start="5">
          <li>
            <strong>BILLING AND RENEWAL POLICIES</strong>
          </li>
        </ol>
        <p>
          Your registration for any Subscription Product will be on either a
          week to week, month-to-month, or year-to-year recurring basis,
          beginning on the date of your registration and continuing for
          recurring periods of either one week, one month or one year, as the
          case may be, from the date of your registration unless and until you
          cancel your registration or we terminate it (in each case in
          accordance with this Agreement). You authorize us to collect the
          applicable subscription payment and applicable taxes each week, month
          or year, as the case may be, of your subscription. You can cancel your
          subscription at any time, but you must cancel your subscription before
          it automatically renews in order to avoid being charged for subsequent
          subscription fees. UNLESS YOU NOTIFY US BEFORE THE BEGINNING OF THE
          NEXT APPLICABLE PERIOD FOR WHICH YOU WISH TO CANCEL YOUR SUBSCRIPTION,
          YOU UNDERSTAND THAT YOUR SUBSCRIPTION WILL AUTOMATICALLY CONTINUE FOR
          A SUCCESSIVE PERIOD OF EQUAL LENGTH TO YOUR ORIGINAL SUBSCRIPTION AND
          YOU AUTHORIZE US TO COLLECT THE APPLICABLE SUBSCRIPTION PAYMENT AND
          APPLICABLE TAXES.
          <br />
          In the event you choose to cancel your subscription before the end of
          it’s term, no refund will be issued and the subscription will expire
          at it’s originally scheduled date.
        </p>
        <p>&nbsp;</p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 6.&nbsp;
          <strong>
            SPECIAL TERMS AND CONDITIONS APPLICABLE TO SUBSCRIPTION PRODUCTS AND
            OTHER SERVICES OR PRODUCTS OFFERED FOR PURCHASE
          </strong>
        </p>
        <p>
          We reserve the right to modify the price of any Subscription Product
          and/or any other services or products offered for purchase through our
          website, apps or social media outlets. We are not responsible for any
          error in copy relating to any Subscription Product or any other
          services or products offered for purchase.
        </p>
        <p>
          In order to purchase a Subscription Product or other services or
          products offered for purchase, you may be required to provide complete
          and accurate personal information, including, without limitation, your
          name, e-mail address, credit card information and billing address. Our
          privacy policy explains how we collect and use such information. Your
          ability to purchase Subscription Products and/or other services or
          products offered for purchase is subject to limits established by your
          credit card issuer. You must notify us immediately of any change in
          your credit card information, including any change to your billing
          address. By utilizing a credit or debit card for purchase of any of
          the Subscription Products or any other services or products offered
          for purchase, you authorize us to charge such card on a periodic basis
          as specified in the amount described on the applicable purchase path
          for such Subscription Product or other services or products offered
          for purchase.
        </p>
        <p>
          By accepting this Agreement, you agree that we may notify you about
          changes to prices and/or Subscription Products by sending an e-mail
          message to your e-mail address on file with us and by publishing such
          notices from time to time on the informational pages of our website.
          It is your responsibility to notify us of any change in your e-mail
          address by logging into our website and using the online account
          management tool. If your e-mail service includes functionality or
          software that catalogues your e-mails in an automated manner, it is
          your responsibility to ensure that those e-mails we send to you reach
          your inbox, either by routinely monitoring your bulk, junk and/or spam
          e-mail folders or by adding us to your address book or safe senders
          list.
        </p>
        <p>&nbsp;</p>
        <ol start="7">
          <li>
            <strong>DISCLAIMER</strong>
          </li>
        </ol>
        <p>
          The materials on Gup’s Corner are provided “as is”. Gup’s Corner, LLC
          makes no warranties, expressed or implied, and hereby disclaims and
          negates all other warranties, including without limitation, implied
          warranties or conditions of merchantability, fitness for a particular
          purpose, or non-infringement of intellectual property or other
          violation of rights. Further, Gup’s Corner, LLC does not warrant or
          make any representations concerning the accuracy, likely results, or
          reliability of the use of the materials on its Internet web site or
          otherwise relating to such materials or on any sites linked to this
          site.
        </p>
        <p>&nbsp;</p>
        <ol start="8">
          <li>
            <strong>LIMITATIONS</strong>
          </li>
        </ol>
        <p>
          In no event shall Gup’s Corner, LLC or its suppliers be liable for any
          damages (including, without limitation, damages for loss of data or
          profit, or due to business interruption,) arising out of the use or
          inability to use the materials on Gup’s Corner, even if Gup’s Corner,
          LLC or a Gup’s Corner, LLC authorized representative has been notified
          orally or in writing of the possibility of such damage. Because some
          jurisdictions do not allow limitations on implied warranties, or
          limitations of liability for consequential or incidental damages,
          these limitations may not apply to you.
        </p>
        <p>&nbsp;</p>
        <ol start="9">
          <li>
            <strong>REGISTRATION OBLIGATIONS</strong>
          </li>
        </ol>
        <p>
          To register on Gup’s Corner you need to enter an email address, log in
          name and password, and you need to agree to these Terms Of Service.
          Since we use your email address to look up your account information,
          and to send you password change requests and other useful
          correspondence you should be sure to use a valid email address when
          registering. You should also keep your email address up to date using
          the My Account page. If you use an invalid email address, you may find
          it difficult to retrieve your password and get customer service.
        </p>
        <p>&nbsp;</p>
        <ol start="10">
          <li>
            <strong>LOG IN NAME, PASSWORD AND SECURITY</strong>
          </li>
        </ol>
        <p>
          You will create a log in name and password when registering with Gup’s
          Corner. The log in name you pick will be unique to the website and no
          other user will have the same log in name. Your password should be
          something easy to remember and should not be the same password you use
          to protect important personal information such as bank and email
          accounts. You are responsible for maintaining the confidentiality of
          your password and are fully responsible for all activities that occur
          under your account. You agree to (a) immediately notify Gup’s Corner
          of any unauthorized use of your account or any other breach of
          security, and (b) ensure that you log off from your account at the end
          of each session. Gup’s Corner cannot and will not be liable for any
          loss or damage arising from your failure to comply with this Section.
        </p>
        <p>&nbsp;</p>
        <ol start="11">
          <li>
            <strong>REVISIONS AND ERRATA</strong>
          </li>
        </ol>
        <p>
          The materials appearing on Gup’s Corner could include technical,
          typographical, or photographic errors. Gup’s Corner, LLC does not
          warrant that any of the materials on its web site are accurate,
          complete, or current. Gup’s Corner, LLC may make changes to the
          materials contained on its web site at any time without notice. Gup’s
          Corner, LLC does not, however, make any commitment to update the
          materials.
        </p>
        <p>&nbsp;</p>
        <ol start="12">
          <li>
            <strong>LINKS</strong>
          </li>
        </ol>
        <p>
          Gup’s Corner, LLC has not reviewed all of the sites linked to its
          Internet web site and is not responsible for the contents of any such
          linked site. The inclusion of any link does not imply endorsement by
          Gup’s Corner, LLC of the site. Use of any such linked web site is at
          the user’s own risk.
        </p>
        <p>&nbsp;</p>
        <ol start="13">
          <li>
            <strong>SITE TERMS OF USE MODIFICATIONS</strong>
          </li>
        </ol>
        <p>
          Gup’s Corner, LLC may revise these terms of use for its web site at
          any time without notice. By using this web site you are agreeing to be
          bound by the then current version of these Terms and Conditions of
          Use.
        </p>
        <p>&nbsp;</p>
        <ol start="14">
          <li>
            <strong>GOVERNING LAW</strong>
          </li>
        </ol>
        <p>
          Any claim relating to Gup’s Corner shall be governed by the laws of
          the State of Texas without regard to its conflict of law provisions.
        </p>
        <p>&nbsp;</p>
        <p>General Terms and Conditions applicable to Use of a Web Site.</p>
      </div>
    </div>
  );
}
